// Auto-generated by scripts/generate-version.js — do not edit
export const BUILD_HASH = "7f902524e4ba";
export const BUILD_VERSION_NUMBER = 20;
